export default __webpack_public_path__ + "static/melbourne-cover-a84cc7386f9d4ad909da2d2ef0bd66c3.jpg";